import type { TOC } from '@ember/component/template-only'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import type ManageRolloverStudentImportInvalidRoute from 'teacher-ui-client/manage/rollover/steps/students/import/invalid/route'
import type ManageRolloverStudentImportInvalidController from 'teacher-ui-client/manage/rollover/steps/students/import/invalid/controller'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import RouteTemplate from 'ember-route-template'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import {
  InlineAlert,
  AlertType,
  InlineAlertSubtitle,
  InlineAlertTitle,
} from 'teacher-ui-client/components/inline-alert'

interface Signature {
  Args: {
    model: ModelFor<ManageRolloverStudentImportInvalidRoute>
    controller: ManageRolloverStudentImportInvalidController
  }
}
export const ManageRolloverStepsStudentsImportInvalidPage: TOC<Signature> = <template>
  <div class="mx-auto">
    <div class="mt-8 mb-12">
      <InlineAlert @type={{AlertType.Critical}} class="mx-auto max-w-3xl">
        <InlineAlertTitle>
          {{t "manage.rollover.steps.students.invalid.upload"}}
        </InlineAlertTitle>
        <InlineAlertSubtitle>
          {{t "manage.rollover.steps.students.invalid.fix"}}
        </InlineAlertSubtitle>
      </InlineAlert>
      <table class="mx-auto mt-6 w-full max-w-6xl">
        <thead>
          <tr class="import-table-header">
            <th class="import-table-cell import-table-header-cell w-16"></th>
            <th class="import-table-cell import-table-header-cell w-48 text-center font-semibold">{{t
                "manage.bulkActions.csv.lineNo"
              }}</th>
            <th class="import-table-cell import-table-header-cell border-0 font-semibold">{{t
                "manage.bulkActions.csv.rowErrorHeading"
              }}</th>
          </tr>
        </thead>
        <tbody class="import-table-body bg-watermelony-red-50">
          {{#each @model.errors as |error index|}}
            <tr class="table-row-striped" data-test-error-row={{index}}>
              <td class="import-table-cell import-table-body-cell bg-deep-orange-50 text-center">
                <PhosphorIcon @icon="phosphor-warning-fill" class="text-watermelony-red-300 h-5 w-5" />
              </td>
              <td
                class="import-table-cell import-table-body-cell bg-deep-orange-50 text-center"
                data-test-error-csv-line-cell
              >
                {{#if error.csvRow}}
                  {{error.csvRow}}
                {{else}}
                  {{t "na"}}
                {{/if}}
              </td>
              <td class="import-table-cell import-table-body-cell bg-deep-orange-50" data-test-error-msg-cell>
                {{error.detail}}
              </td>
            </tr>
          {{/each}}
        </tbody>
      </table>

      <div class="mx-auto mt-8 flex max-w-3xl items-center justify-between px-2">
        <UiButton
          @appearance={{ButtonAppearance.muted}}
          class="mr-8 w-40 whitespace-nowrap"
          {{on "click" @controller.cancel}}
        >
          {{t "manage.bulkActions.csv.cancel"}}
        </UiButton>
        <label data-test-upload-students-csv>
          <input class="hidden" type="file" accept="text/csv, .csv" {{on "change" @controller.selectCsvFile}} />
          <UiButtonLink class="w-48 whitespace-nowrap" @appearance={{ButtonAppearance.regular}}>
            {{t "manage.bulkActions.csv.reupload"}}
          </UiButtonLink>
        </label>
      </div>
    </div>
  </div>
</template>

export default RouteTemplate(ManageRolloverStepsStudentsImportInvalidPage)
